import RareBoxLogo from "Logos/RareBoxLogo";

import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import React, { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

const BuyingDashboardContext = createContext();

const BuyingDashboardProvider = () => {
	const [cache, setCache] = useState({});

	const [buyingList, setBuyingList] = useState([]);

	useEffect(() => {
		const fetch = async () => {
			try {
			} catch (error) {
				console.log(error);
			}
		};
		fetch();
	}, []);

	const getBuyingCache = (key) => cache[key] ?? null;

	const setBuyingCache = (key, data) => {
		setCache((prev) => ({
			...prev,
			[key]: data,
		}));
	};

	return (
		<BuyingDashboardContext.Provider
			value={{
				buyingList,
				setBuyingList,
				getBuyingCache,
				setBuyingCache,
			}}>
			{true ? (
				<Outlet />
			) : (
				<div
					style={{
						width: "160px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo width="100%" />
					<CustomLinearProgress height="4px" />
				</div>
			)}
		</BuyingDashboardContext.Provider>
	);
};

export const BuyingDashboardState = () => {
	return useContext(BuyingDashboardContext);
};

export default BuyingDashboardProvider;
